// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"6d248e97","456":"4a55d8c2","656":"557d95b0","756":"2d7da033","787":"9778eb58","968":"b6dfb107"}[chunkId] + ".chunk.js";
};